<script>
import DidoDatasetCard from "./components/DatasetCard.vue";

export default {
  name: "DidoDatasetCardCe",
  components: {
    DidoDatasetCard,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoDatasetId: { type: String, required: true },
  },
  emits: [
    "dataset-retrieved",
    "dataset-not-retrieved",
    "click-card",
    "label-selection",
    "bad-configuration",
  ],
  template: `
    <DidoDatasetCard
      :api-url="didoUrl"
      :dataset-id="didoDatasetId"
      @dataset-retrieved="$emit('dataset-retrieved', $event)"
      @dataset-not-retrieved="$emit('dataset-not-retrieved', $event)"
      @click-card="$emit('click-card', $event)"
      @label-selection="$emit('label-selection', $event)"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
